"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bindAndScopeChange_1 = require("@guestbell/slate-common/lib/utils/bindAndScopeChange");

var options_1 = __importDefault(require("./options"));

var utils_1 = require("./utils");

var changes_1 = require("./changes");

var validation_1 = require("./validation");
/**
 * The core of the plugin, which does not relies on `slate-react`, and includes
 * everything but behavior and rendering logic.
 */


function core(optsParam) {
  var opts = new options_1.default(optsParam);
  return {
    schema: validation_1.schema(opts),
    utils: {
      isSelectionInBlockquote: utils_1.isSelectionInBlockquote(opts)
    },
    changes: {
      wrapInBlockquote: changes_1.wrapInBlockquote(opts),
      unwrapBlockquote: bindAndScopeChange_1.bindAndScopeChange(opts, bindAndScopeChangeCondition, changes_1.unwrapBlockquote)
    }
  };
}

var bindAndScopeChangeCondition = function bindAndScopeChangeCondition(opts, editor) {
  return utils_1.isSelectionInBlockquote(opts)(editor.value);
};

exports.default = core;